import { FontSizeTokens, FontFamilyTokens, ColorTokens, TypographyTypeTokens, } from '@voltmoney/schema';
export const fontFamilyTokensMap = {
    [FontFamilyTokens.Inter]: FontFamilyTokens.Inter,
    [FontFamilyTokens.Poppins]: FontFamilyTokens.Poppins,
};
export const fontSizeTokensMap = {
    [FontSizeTokens.SIZE_8]: 8,
    [FontSizeTokens.XXS]: 10,
    [FontSizeTokens.XS]: 12,
    [FontSizeTokens.SM]: 14,
    [FontSizeTokens.MD]: 16,
    [FontSizeTokens.LG]: 18,
    [FontSizeTokens.XL]: 20,
    [FontSizeTokens.XXL]: 24,
    [FontSizeTokens.XXXL]: 28,
    [FontSizeTokens.XXXXL]: 32,
    [FontSizeTokens.XXXXXL]: 40,
    [FontSizeTokens.XXXXXXL]: 48,
    [FontSizeTokens.XXXXXXXL]: 60,
};
export const typographyTypeTokensMap = {
    [TypographyTypeTokens.DEFAULT]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.SM,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.H7]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.XXS,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.H6]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.XS,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.H5]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.SM,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.H4]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.MD,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.H3]: {
        color: ColorTokens.Grey_Night,
        fontSize: FontSizeTokens.LG,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.H2]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.XL,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.H1]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.XXL,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.B7]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.XXS,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.B6]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.XS,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.B5]: {
        color: ColorTokens.Grey_400,
        fontSize: FontSizeTokens.SM,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.B4]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.MD,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.B3]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.LG,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.S1]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.XXL,
        fontFamily: FontFamilyTokens.Poppins,
    },
    [TypographyTypeTokens.S2]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.XL,
        fontFamily: FontFamilyTokens.Poppins,
    },
    [TypographyTypeTokens.S3]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.LG,
        fontFamily: FontFamilyTokens.Poppins,
    },
    [TypographyTypeTokens.S4]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.MD,
        fontFamily: FontFamilyTokens.Poppins,
    },
    [TypographyTypeTokens.S5]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.SM,
        fontFamily: FontFamilyTokens.Poppins,
    },
    [TypographyTypeTokens.S6]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.XS,
        fontFamily: FontFamilyTokens.Poppins,
    },
    [TypographyTypeTokens.S7]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.XXS,
        fontFamily: FontFamilyTokens.Poppins,
    },
    [TypographyTypeTokens.P5]: {
        color: ColorTokens.Grey_300,
        fontSize: FontSizeTokens.SM,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.primary]: {
        color: ColorTokens.Grey_500,
        fontSize: FontSizeTokens.SM,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.secondary]: {
        color: ColorTokens.Grey_400,
        fontSize: FontSizeTokens.SM,
        fontFamily: FontFamilyTokens.Inter,
    },
    [TypographyTypeTokens.placeholder]: {
        color: ColorTokens.Grey_300,
        fontSize: FontSizeTokens.SM,
        fontFamily: FontFamilyTokens.Inter,
    },
};
